module.exports = __webpack_public_path__ + "img/redtable.7881ba09.webp";